export class ForgotPassword {
    public static readonly type = '[RootState] Forgot password';

    constructor(public email: string) {}
}
